import * as React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { useDrawingArea } from '@mui/x-charts/hooks';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const data = [
  { value: 50, label: 'Orphan' },
  { value: 1000, label: 'Quarantine' },
  { value: 1500, label: 'Waiting to ship' },
];

const StyledText = styled('text')(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: 'middle',
  dominantBaseline: 'central',
  fontSize: 16,
}));

function PieCenterLabel({ children }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <StyledText x={left + width / 2} y={top + height / 2}>
      {children}
    </StyledText>
  );
}

export default function PieChartWithCenterLabel({ height = 250, width = 300 }) {
  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <PieChart 
            series={[
                { 
                    data, 
                    innerRadius: 60, 
                    outerRadius: 100,
                    paddingAngle: 2,
                    cornerRadius: 4,
                }
            ]} 
            height={height} 
            width={width}
            slotProps={{
                legend: {
                    direction: 'row',
                    position: { vertical: 'bottom', horizontal: 'middle' },
                    padding: 0,
                },
            }}
        >
          <PieCenterLabel>Total</PieCenterLabel>
        </PieChart>
    </Box>
  );
}